import { BaseEntity } from "./../baseEntity";
export class GroupAddressRequest {
}
export class GroupRequest extends BaseEntity {
}
export class GroupResponse extends BaseEntity {
}
